import React, { useMemo, useState } from "react";
import Card from "react-bootstrap/Card";
import { Row, Col, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { BiBookmarkAlt, BiBuildings, BiMobileAlt, BiLogoGmail, BiCurrentLocation, BiLoader } from "react-icons/bi";
import { getUserData } from "../../utils/common";
import { makeRequest } from "../../utils/makeRequest";
import * as urls from '../../utils/urlConst';
import toastNotify from "../../utils/toastNotify";
import Loader from "../../components/Loader";
import TicketChrt from "./TicketChrt";
import Popup from "./Popup";
import { handleNotificationLoader, handleNotificationData } from "../../redux/Notification";
import { useDispatch } from "react-redux";
import { exceptionLog } from "../../utils/common";
import { getNotificationAlerts } from "../../apiService/apiService";
import { useParamters } from "../../hooks/hooks";

type ticketCountProps = {
  CloseTicket: string,
  InprocessTicket: string,
  OpenTicket: string,
  PendingTicket: string,
}

type getTicketProps = {
  BankCode: string,
  CategoryName: string,
  CreateBy: string,
  LastActivity: string,
  LastReplier: string,
  Priority: string,
  StatusCode: string,
  StatusName: string,
  SubCategoryName: string,
  Subject: string,
  TicketId: string,
  TicketType: string,
  TranCode: string,
}

const Dashboard = () => {

  const isPopupAnnouncement = () => {
    const popup: any = window.localStorage.getItem("pop-up-announcement");
    return popup ? JSON.parse(popup) : true;
  };

  const screenWidth = useSelector((state: any) => state.layout.currentScreenWidth);
  const userData = getUserData();
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [ticketCount, setTicketCount] = useState<ticketCountProps | any>({});
  const [ticketData, setTicketData] = useState<getTicketProps[]>([]);
  const [seriesInternalData, setSeriesInternalData] = useState<number[] | never[]>([]);
  const [isPopupMdlAnnouncement, setPopupMdlAnnouncemet] = useState<boolean>(false);
  const [popupAnnouncementData, setPopupAnnouncementData] = useState<any>([]);
  const [showPopupAnnouncement, setShowPopupAnnouncemet] = useState<boolean>(isPopupAnnouncement());
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const parameters = useParamters(["9008"]);
  const isShowReOpenTicketCounts = parameters.find((items: any) => items.paraCode === "9008")?.paraValue;

  const fetchAnnouncement = async () => {
    try {
      setIsLoader(true);
      const payload = {};
      const config = {};
      await makeRequest('POST', urls.getAnnouncementAlert, payload, config).then((result) => {
        if (result.STATUS === '0') {
          const response = result.RESPONSE;
          const getPopData = response.filter((items: any) => items.PopUpAlert === "Y");
          if (getPopData.length !== 0) {
            setPopupMdlAnnouncemet(true);
            setPopupAnnouncementData(getPopData);
          }
        } else {
          result.MESSAGE !== "No Data Found" && result.MESSAGE !== "No data found" && toastNotify(result.MESSAGE, 'error');
        };
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Get announcement alerts", "N");
      }
    } finally {
      setIsLoader(false);
    }
  };

  // ------------------------------------- this function called dashboard tiket count API start -------------------------------------

  const fetchDashboardTicketCount = async () => {
    try {
      setIsLoader(true);
      const payload = {};

      const config = {};

      await makeRequest('POST', urls.dashboardTicketCount, payload, config).then((result) => {
        if (result.STATUS === '0') {
          const response = result.RESPONSE[0];
          setTicketCount(response);
          setSeriesInternalData([
            isShowReOpenTicketCounts === "Y" ? response?.ReOpenTicket : response?.PendingTicket,
            response?.OpenTicket,
            response?.InprocessTicket,
            response?.CloseTicket
          ]);
        } else {
          result.MESSAGE !== "No Data Found" && result.MESSAGE !== "No data found" && toastNotify(result.MESSAGE, 'error');
        };
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Dashboard tickets count", "N");
      }
    } finally {
      setIsLoader(false);
    }
  };
  // ------------------------------------- this function called dashboard tiket count API end -------------------------------------


  // ------------------------------------- this function called dashboard tiket API Start -------------------------------------

  const fetchDashboardTickets = async () => {
    try {
      setIsLoader(true);
      const payload = {};
      const config = {};
      await makeRequest('POST', urls.dashboardTickets, payload, config).then((result) => {
        if (result.STATUS === '0') {
          const response = result.RESPONSE;
          setTicketData(response);
        } else {
          result.MESSAGE !== "No Data Found" && result.MESSAGE !== "No data found" && toastNotify(result.MESSAGE, 'error');
        };
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Dashboard tickets", "N");
      }
    } finally {
      setIsLoader(false);
    }
  };

  // ------------------------------------- this function called dashboard tiket API end -------------------------------------

  const fetchNotification = async () => {
    try {
      dispatch(handleNotificationLoader(true));
      const notificationData = await getNotificationAlerts();
      dispatch(handleNotificationData(notificationData))
    } catch (error: any) {
      // Ignore Case  
    } finally {
      dispatch(handleNotificationLoader(false));
    }
  };

  useMemo(() => {
    (async () => {
      if (showPopupAnnouncement) {
        await fetchAnnouncement();
      }
      await fetchNotification();
      await fetchDashboardTicketCount();
      await fetchDashboardTickets();
    })();
  }, []);

  // ------------------------------------- this function called dashboard tiket details API start -------------------------------------

  const fetchTicketDetails = async (ticketId: string) => {
    try {
      setIsLoader(true);
      const payload = {
        TicketId: ticketId,
      };

      const config = {};
      await makeRequest('POST', urls.getTicketDetails, payload, config).then((result) => {
        if (result.STATUS === '0') {
          const response = result.RESPONSE[0];
          navigate('/tickets/viewdetails', {
            state: {
              response: { ...response, TicketData: ticketId },
            }
          })
        } else {
          result.MESSAGE !== "No Data Found" && result.MESSAGE !== "No data found" && toastNotify(result.MESSAGE, 'error');
        }
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Get ticket details", "N");
      }
    } finally {
      setIsLoader(false);
    }
  };

  const fetchTicketList = async (tktStatus?: string) => {
    try {
      setIsLoader(true);
      const payload = {
        TicketId: "",
        StatusCode: "All",
        StatusType: "",
        ActionType: "D",
        DashboardTktStatus: tktStatus,
      };

      const config = {};
      await makeRequest('POST', urls.getTicket, payload, config).then((result) => {
        if (result.STATUS === '0') {
          const response = result.RESPONSE;
          navigate("/tickets", { state: response })
        } else {
          setTicketData([]);
          result.MESSAGE !== "No Data Found" && result.MESSAGE !== "No data found" && toastNotify(result.MESSAGE, 'error');
        }
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Get tickets", "N");
      }
    } finally {
      setIsLoader(false);
    }
  };


  // ------------------------------------- this function called dashboard tiket details API end -------------------------------------

  return (
    <div className="dashboard-Section">

      <Row className="mt-3">
        <Col md={3} className="mt-2 mt-md-0">
          <Card>
            <Card.Body className="d-flex align-items-center">
              <div className="cardIcon">
                <BiBookmarkAlt className="text-orange" />
              </div>
              <div className={`ms-3 ${(Number(ticketCount.PendingTicket) > 0 || Number(ticketCount.ReOpenTicket) > 0) && "download-btn"} `} onClick={() => { isShowReOpenTicketCounts === "Y" ? (Number(ticketCount.ReOpenTicket) > 0 && fetchTicketList("R")) : (Number(ticketCount.PendingTicket) > 0 && fetchTicketList("P")) }}>
                <h5 className="text-base mb-0">{!isLoader ? (isShowReOpenTicketCounts === "Y" ? ticketCount.ReOpenTicket : ticketCount.PendingTicket) : <BiLoader className='icon-loader text-lg' />}</h5>
                <div className="text-sm">{isShowReOpenTicketCounts === "Y" ? "Re-Open" : "Pending"}</div>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={3} className="mt-2 mt-md-0">
          <Card>
            <Card.Body className="d-flex align-items-center">
              <div className="cardIcon">
                <BiBookmarkAlt className="text-orange" />
              </div>
              <div className={`ms-3 ${Number(ticketCount.OpenTicket) > 0 && "download-btn"} `} onClick={() => { Number(ticketCount.OpenTicket) > 0 && fetchTicketList("O") }}>
                <h5 className="text-base mb-0">{!isLoader ? ticketCount.OpenTicket : <BiLoader className='icon-loader text-lg' />}</h5>
                <div className="text-sm">Open</div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} className="mt-2 mt-md-0">
          <Card>
            <Card.Body className="d-flex align-items-center">
              <div className="cardIcon">
                <BiBookmarkAlt className="text-orange" />
              </div>
              <div className={`ms-3 ${Number(ticketCount.InprocessTicket) > 0 && "download-btn"} `} onClick={() => { Number(ticketCount.InprocessTicket) > 0 && fetchTicketList("I") }}>
                <h5 className="text-base mb-0">{!isLoader ? ticketCount.InprocessTicket : <BiLoader className='icon-loader text-lg' />}</h5>
                <div className="text-sm">In-Process</div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} className="mt-2 mt-md-0">
          <Card>
            <Card.Body className="d-flex align-items-center">
              <div className="cardIcon">
                <BiBookmarkAlt className="text-orange" />
              </div>
              <div className={`ms-3 ${Number(ticketCount.CloseTicket) > 0 && "download-btn"} `} onClick={() => { Number(ticketCount.CloseTicket) > 0 && fetchTicketList("C") }}>
                <h5 className="text-base mb-0">{!isLoader ? ticketCount.CloseTicket : <BiLoader className='icon-loader text-lg' />}</h5>
                <div className="text-sm">Close</div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md={8}>
          <h6 className="pe-2 mt-3">Summary</h6>
          <Card className="ticket-chart">
            <Card.Body>
              {!isLoader ?
                <TicketChrt seriesInternalData={seriesInternalData} isShowReOpenTicketCounts={isShowReOpenTicketCounts} />
                : <div style={{ height: '300px' }} className='d-flex justify-content-center align-items-center'>
                  <Loader />
                </div>
              }
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <h6 className="pe-2 mt-3">Organization Details</h6>
          <Card>
            <Card.Body className="highPriorityTicketonDashboard">
              <div className="d-flex justify-content-center mb-2">
                <div className="organization-Icon border d-flex justify-content-center align-items-center">
                  <BiBuildings style={{ fontSize: 40 }} />
                </div>
              </div>
              <div className="text-center">
                <div className="text-sm text-slate-700 text-center">{userData.BankName}</div>
              </div>

              <div className="w-100 rounded mt-2 p-2 organization-details">
                <div className='d-flex align-items-center pb-2 border-bottom'>
                  <div style={{ width: 35, height: 35, backgroundColor: '#f5429350' }} className='rounded d-flex justify-content-center align-items-center'>
                    <BiMobileAlt style={{ color: '#f54293' }} />
                  </div>
                  <div className="ms-2">
                    <div className='text-xs text-slate-500'>Organization contact No.</div>
                    <div className="text-sm">{userData.BankMobileNo}</div>
                  </div>
                </div>

                <div className='d-flex align-items-center py-2 border-bottom'>
                  <div style={{ width: 35, height: 35, backgroundColor: '#f5693650' }} className='rounded d-flex justify-content-center align-items-center'>
                    <BiCurrentLocation style={{ color: '#f56936' }} />
                  </div>
                  <div className="ms-2">
                    <div className='text-xs text-slate-500'>Address</div>
                    <div className="text-sm">{userData.BankAddress}</div>
                  </div>
                </div>

                <div className='d-flex align-items-center py-2'>
                  <div style={{ width: 35, height: 35, backgroundColor: '#2bab5a50' }} className='rounded d-flex justify-content-center align-items-center'>
                    <BiLogoGmail style={{ color: '#2bab5a' }} />
                  </div>
                  <div className="ms-2">
                    <div className='text-xs text-slate-500'>Email Id</div>
                    <div className="text-sm">{userData.BankEmailId}</div>
                  </div>
                </div>

              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <h6 className="pe-2 mt-3">Recent Tickets</h6>
      <Card>
        <Card.Body className={`highPriorityTicketonDashboard p-0 ${ticketData.length === 0 && 'd-flex justify-content-center align-items-center'}`}>
          {!isLoader ? <>
            {ticketData.length !== 0 ?
              <div className="ticketList">
                {ticketData.map((item: any, id: any) => (
                  <div
                    key={id}
                    className={`w-100 d-flex border-bottom py-2 px-3 ticketRow align-items-center ${item.ReadStatus === "N" ? "ticket-unread" : ""}`}
                    onClick={() => fetchTicketDetails(item.TicketId)}
                  >
                    <div>
                      {(item.Priority === 'H' && <div style={{ width: 40, height: 40, borderRadius: "100%" }} className='d-flex justify-content-center align-items-center badge bg-danger me-2'>HI</div>) ||
                        (item.Priority === 'M' && <div style={{ width: 40, height: 40, borderRadius: "100%" }} className='d-flex justify-content-center align-items-center badge bg-warning me-2'>MD</div>) ||
                        (item.Priority === 'L' && <div style={{ width: 40, height: 40, borderRadius: "100%" }} className='d-flex justify-content-center align-items-center badge bg-success me-2'>LW</div>) ||
                        <div style={{ width: 40, height: 40, borderRadius: "100%" }} className='d-flex justify-content-center align-items-center badge bg-danger me-2'>HI</div>}
                    </div>

                    <div>
                      <div className={`d-flex ${screenWidth <= 600 ? "flex-column" : "align-items-center"}`}>
                        <span className="text-slate-700 ms-1 text-sm">
                          #{item.TicketId}
                        </span>
                        <div
                          className={`text-base mb-0 ms-2 text-slate-700 ${screenWidth <= 600 && "ticketSubJect"}`}
                        >
                          {item.Subject}
                        </div>
                      </div>

                      {screenWidth >= 600 &&
                        <div className="d-flex align-items-center">
                          <div className="border-end pe-2 text-xs text-slate-500">{item.CategoryName}</div>
                          {item.SubCategoryName !== "" &&
                            <div className="border-end px-2 text-xs text-slate-500">{item.SubCategoryName}</div>
                          }
                          {item.TicketType === "S" && (
                            <div className="border-end px-2 text-xs text-slate-500">Service</div>
                          )}
                          {item.TicketType === "T" && (
                            <div className="border-end px-2 text-xs text-slate-500">Transaction</div>
                          )}
                          <div className="border-end px-2 text-xs text-slate-500">{item.LastActivity}</div>
                          <div className="border-end px-2 text-xs text-slate-500">{item.ReplayCount} Reply</div>
                          <div className="d-flex align-items-center px-2 text-xs text-slate-500">
                            {item.CreateDate}
                          </div>
                        </div>
                      }
                    </div>

                    <div className={`ms-auto  d-flex gap-2 align-items-center`}>
                      <div>
                        {item.StatusName === 'O' && <Badge bg="success">Open</Badge>}
                        {item.StatusName === 'C' && <Badge bg="danger">Closed</Badge>}
                        {item.StatusName === 'P' && <Badge bg="primary">Pending</Badge>}
                        {item.StatusName === 'I' && <Badge bg="warning">In-Process</Badge>}
                        {item.StatusName === 'R' && <Badge bg="success">Re-Open</Badge>}
                        {item.StatusName === 'A' && <Badge bg="info">Assigned</Badge>}
                        {item.StatusName !== 'O' && item.StatusName !== 'C' && item.StatusName !== 'P' && item.StatusName !== 'I' && item.StatusName !== 'R' && item.StatusName !== 'A' ? <Badge bg="warning">{item.StatusName}</Badge> : ''}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              :
              <div>
                <img src="/imgaes/svg/55024593_9264820.svg" alt="No Data Found" style={{ width: 200 }} />
                <h1 className="text-base text-center">No complaint ticket found</h1>
              </div>
            }
          </>
            : <div style={{ height: '300px' }} className='d-flex justify-content-center align-items-center'>
              <Loader />
            </div>
          }
        </Card.Body>
      </Card>

      <Popup isPopupMdl={isPopupMdlAnnouncement} setPopupMdl={setPopupMdlAnnouncemet} popupData={popupAnnouncementData} setShowPopup={setShowPopupAnnouncemet} />
    </div>
  );
};

export default Dashboard;
